import { TextInput } from "~/components/TextInput";
import { Box, Stack } from "./CertificateInput.styled";

interface CertificateInputProps {
  password: string;
  setPassword: (password: string) => void;
  licenseType?: string;
  setLicenseType?: (licenseType: string) => void;
}

const CertificateInput = ({
  password,
  setPassword,
  licenseType,
  setLicenseType,
}: CertificateInputProps) => {
  return (
    <Box className="certificate-input-wrapper">
      <Stack className="input-container">
        <Box className="input-label">인증서 암호</Box>
        <Box className="text-field">
          <TextInput
            type="password"
            placeholder="인증서 암호를 입력해주세요."
            value={password}
            onChange={setPassword}
            autoComplete="new-password"
          />
        </Box>
      </Stack>
      {licenseType !== undefined && (
        <Stack className="input-container">
          <Box className="input-label">의사면허번호</Box>
          <Box className="text-field">
            <TextInput
              placeholder="의사면허번호를 입력해주세요."
              value={licenseType}
              onChange={setLicenseType}
            />
          </Box>
        </Stack>
      )}
    </Box>
  );
};

export default CertificateInput;
